import { ChannelOptions } from 'ably';
import { ChannelProvider as AblyChannelProvider } from 'ably/react';
import { PropsWithChildren, useContext } from 'react';

import AppContext from '@/contexts/appContext';

import { Props } from './types';

const ChannelProvider = ({ channelName, children, options = {} }: PropsWithChildren<Props>) => {
  const { config } = useContext(AppContext);
  const DEFAULT_CHANNEL_OPTIONS: ChannelOptions = {
    cipher: {
      algorithm: 'aes',
      key: config.PUBLIC_CHANNEL_WEBSOCKET_KEY,
      keyLength: 256,
      mode: 'cbc'
    }
  };

  return (
    <AblyChannelProvider
      channelName={channelName}
      options={{ ...DEFAULT_CHANNEL_OPTIONS, ...options }}>
      {children}
    </AblyChannelProvider>
  );
};

export default ChannelProvider;
